import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=82c82972&scoped=true"
import script from "./chart.ts?vue&type=script&lang=ts&external"
export * from "./chart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c82972",
  null
  
)

export default component.exports